import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-logo",
  "use": "icon-logo-usage",
  "viewBox": "0 0 135 38",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 135 38\" id=\"icon-logo\">\r\n<image x=\"0px\" y=\"0px\" width=\"135px\" height=\"38px\" xlink:href=\"\"></image>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol